// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","tablet":"(max-width: 1024px)","wrapper":"_3mZYOq5unqlA","title":"dgSkxpgBL6Mv","resendButton":"_3BZv1QMWEgQM","doneIcon":"n_vn7Yhz0ZPo"};